import React from 'react';
import PropTypes from 'prop-types';


const propTypes = {
    feedI: PropTypes.object
}


export default class FeedItem extends React.Component{
    constructor (props) {
        super(props);
    }

    render(){

        const {feedI} = this.props;

        const{title, category, description, featuredImage, link, download, ctaLable, layout, overlay} = feedI;
        let isValid = link;

        const myCta = (
            <div className="btn btn-default btn-primary btn-signup">{ctaLable}</div>
        );

        return(
            <div>
                {isValid ?
                    <a className='feed-item-active' href={link} download={download}>
                        <div className='feedI-content-holder'>
                            <div className='feedi--image--holder'>
                                <img src={featuredImage} className='feedi-img'/>
                            </div>
                            <div className='feedi-text-holder'>
                                <h5 className='feed-item-title'>{title}{category}</h5>
                                <p className='feed-item-description'>{description}</p>
                                <div className='feed-item-cta'>{myCta}</div>
                            </div>
                        </div>
                    </a>
                    : <div className='feed-item-inactive'>
                        <div className='feedI-content-holder'>
                            <div className='feedi--image--holder'>
                                <img src={featuredImage} className='feedi-img'/>
                            </div>
                            <div className='feedi-text-holder'>
                                <h5 className='feed-item-title'>{title}{category}</h5>
                                <p className='feed-item-description'>{description}</p>
                            </div>
                        </div>
                    </div>
                }
            </div>
        )
    }
}

FeedItem.propTypes = propTypes;


// WEBPACK FOOTER //
// ./src/components/Feed/FeedItem.js